<template>
  <Header title="about" />
  <Container>
    <h2>Ultrack Philosophy</h2>
    <p>
      Our founders' history started over 45 years ago in the automotive industry
      as a licensed mechanic with an innovative mind. Technological advances in
      the industry required a higher skill set that led him to the
      telecommunications sector.
      <br /><br />
      One of the major telecommunication projects was the 3G "Inukshuk"
      initiative that involved providing high speed cellular/internet service
      for the upcoming Winter Olympic Games.
      <br /><br />
      The next step in the telecommunications industry was the newly evolving
      fleet tracking sector using GPS and cellular technology.
      <br /><br />
      This led to the first pilot project of its kind in the industry. It
      involved placing tracking hardware into a fleet of service vehicles to
      track their movements and location online.
      <br /><br />
      As the fleet tracking industry progressed new challenges and opportunities
      arose.
      <br /><br />
      A project came along that required a taxi company with 1700+ cabs that
      required installations be completed within a 6 month period. Upon
      completion of this project the inspiration to start Ultrack was born.
      <br /><br />
      Our goal is to continue to be innovative in the products we develop and to
      provide the best service to our clients to keep them ahead of the
      competition.
    </p>
  </Container>
</template>

<script>
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";

export default {
  components: {
    Container,
    Header,
  },
};
</script>
